import type { TestimonialButtonHoverSettingsFormType } from '@web/widgets/testimonial/type/testimonial-widget.type';
import {
    type TestimonialButtonBaseSettingsFormType,
    type TestimonialButtonSettingsFormType,
    type TestimonialSettingsFormType,
    type TestimonialWidgetDataFormType,
} from '@web/widgets/testimonial/type/testimonial-widget.type';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

export const settingsForm = (): FormGroup<TestimonialSettingsFormType> =>
    new FormGroup({
        rowItems: new FormControl(null),
        spaceBetween: new FormControl(null),
        isShortText: new FormControl(null),
        isShowMore: new FormControl(null),
        buttonColor: new FormControl(null),
        isAutoScroll: new FormControl(null),
        type: new FormControl(null),
        linkText: new FormControl(null),
        linkColor: new FormControl(null),
        fontSize: new FormControl(null),
        fontStyle: new FormControl(null),
        fontColor: new FormControl(null),
        backgroundColor: new FormControl(null),
        isBorder: new FormControl(null),
        borderWidth: new FormControl(null),
        borderStyle: new FormControl(null),
        borderColor: new FormControl(null),
        isShadow: new FormControl(null),
        rounding: new FormControl(null),
        paddingTop: new FormControl(null),
        paddingBottom: new FormControl(null),
        paddingLeft: new FormControl(null),
        paddingRight: new FormControl(null),
    });

const testimonialButtonBaseSettingsForm = (): FormGroup<TestimonialButtonBaseSettingsFormType> =>
    new FormGroup<TestimonialButtonBaseSettingsFormType>({
        color: new FormControl(null),
        background: new FormControl(null),
        borderColor: new FormControl(null),
        borderWidth: new FormControl(null),
        borderRadius: new FormControl(null),
        borderStyle: new FormControl(null),
    });

const testimonialButtonHoverSettingsForm = (): FormGroup<TestimonialButtonHoverSettingsFormType> =>
    new FormGroup<TestimonialButtonHoverSettingsFormType>({
        hoverType: new FormControl(null),
        opacity: new FormControl(null),
        shadow: new FormControl(null),
        color: new FormControl(null),
        background: new FormControl(null),
        borderColor: new FormControl(null),
    });

export const testimonialButtonSettingsForm = (): FormGroup<TestimonialButtonSettingsFormType> =>
    new FormGroup<TestimonialButtonSettingsFormType>({
        size: new FormControl(null),
        label: new FormControl(null),
        styleType: new FormControl(null),
        buttonBase: testimonialButtonBaseSettingsForm(),
        buttonHover: testimonialButtonHoverSettingsForm(),
    });

export const testimonialWidgetDataFormGroup = (): FormGroup<TestimonialWidgetDataFormType> =>
    new FormGroup({
        layout: new FormControl(null),
        testimonialCount: new FormControl(null),
        selectedCourseId: new FormControl(null),
        settings: settingsForm(),
        items: new FormArray([]),
        buttonSettings: testimonialButtonSettingsForm(),
    });
